<!-- src/views/HolidayRequestView.vue -->
<template>
  <div class="container holiday-request-view">
    <div class="page-header">
      <div>
        <h3>Holiday Requests</h3>
        <div class="grey-text">Review, approve and reject staff holiday requests.</div>
      </div>
    </div>

    <div v-if="loading" class="card holiday-loading-card">
      <div class="card-content">
        <span class="grey-text">Loading holiday requests…</span>
      </div>
    </div>

    <HolidayApprovalPanel
      v-else
      :key="resolvedVenueId || 'no-venue'"
      :venue-id="resolvedVenueId"
      :venue-name="venueName"
    />
  </div>
</template>

<script>
import { db } from "@/firebase";
import { doc, getDoc } from "firebase/firestore";

import HolidayApprovalPanel from "@/components/holiday/HolidayApprovalPanel.vue";
import { useVenueContext } from "@/scripts/useScripts/useVenueContext";

function clean(s) {
  return String(s ?? "").trim();
}

export default {
  name: "HolidayRequestView",

  components: {
    HolidayApprovalPanel,
  },

  props: {
    venueId: {
      type: String,
      default: "",
    },
  },

  setup() {
    const { venueId } = useVenueContext();

    return {
      contextVenueId: venueId,
    };
  },

  data() {
    return {
      loading: true,
      resolvedVenueId: "",
      venueName: "",
    };
  },

  computed: {
    activeVenueId() {
      return clean(
        this.$route?.params?.venueId || this.venueId || this.contextVenueId || ""
      );
    },
  },

  watch: {
    activeVenueId: {
      immediate: true,
      async handler() {
        await this.bootstrap();
      },
    },
  },

  methods: {
    async bootstrap() {
      this.loading = true;
      this.venueName = "";

      try {
        this.resolvedVenueId = this.activeVenueId;

        if (!this.resolvedVenueId) {
          return;
        }

        await this.loadVenueName();
      } finally {
        this.loading = false;
      }
    },

    async loadVenueName() {
      try {
        const snap = await getDoc(doc(db, "venues", this.resolvedVenueId));

        if (!snap.exists()) {
          this.venueName = this.resolvedVenueId;
          return;
        }

        const data = snap.data() || {};

        this.venueName =
          clean(data.venue_name) ||
          clean(data.venueName) ||
          clean(data.name) ||
          clean(data.title) ||
          clean(data.label) ||
          this.resolvedVenueId;
      } catch (e) {
        console.warn("[HolidayRequestView] venue lookup failed:", e);
        this.venueName = this.resolvedVenueId;
      }
    },
  },
};
</script>

<style scoped>
.holiday-request-view {
  max-width: 1400px;
  margin-top: 22px;
  padding-bottom: 40px;
}

.page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 18px;
  flex-wrap: wrap;
}

.page-header h3 {
  margin: 0 0 8px 0;
}

.holiday-loading-card {
  border-radius: 12px;
}

@media (max-width: 600px) {
  .holiday-request-view {
    width: 96%;
    margin-top: 14px;
    padding-bottom: 28px;
  }

  .page-header {
    display: block;
    margin-bottom: 14px;
  }

  .page-header h3 {
    font-size: 1.9rem;
    line-height: 1.2;
  }

  .holiday-loading-card .card-content {
    padding: 16px;
  }
}
</style>
